// extracted by mini-css-extract-plugin
export default {"EditNamePage":"styles_EditNamePage__-bUFH","fullWidth":"styles_fullWidth__E27gu"};